/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import { IParnerPassedOn } from '../../../../../../../redux/duck/legado/faresApp/tedFares/interfaces/reduxInterfaces';
import Card from '../../../../../../../shared/components/Card';
import { ContentCard } from '../../../../../../../shared/components/Card/components/CardComponents';
import checkValue from '../../../../../../../utils/values';
import TableComponents from './components/TableComponents';

interface ICardWithTable {
  isActive: boolean;
  gridArea?: string;
  title: string;
  subtitle: string;
  valueColor: string;
  data: IParnerPassedOn[];
  pdf?: {
    title: string;
    body: any;
  };
}

function CardWithTable(props: ICardWithTable) {
  let totalIncome = 0;
  let totalReceived = 0;
  let totalPassedOn = 0;

  return (
    <Card
      isActive={props.isActive}
      title={props.title}
      gridArea={props.gridArea}
      subtitle={props.subtitle}
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      width="100%"
      height="100%"
      backgroundColor="#FFFFFF">
      <ContentCard>
        <TableComponents.Table>
          <TableComponents.Thead>
            <TableComponents.Tr>
              <TableComponents.Td>Parceiro</TableComponents.Td>
              <TableComponents.Td>Tarifa Recebida</TableComponents.Td>
              <TableComponents.Td>Tarifa Repassada</TableComponents.Td>
              <TableComponents.Td>Resultado</TableComponents.Td>
            </TableComponents.Tr>
          </TableComponents.Thead>
          <TableComponents.Tbody textColor={props.valueColor}>
            {props.data.map((partner) => {
              totalIncome += partner.income;
              totalPassedOn += partner.valuePassedOn;
              totalReceived += partner.valueReceived;

              return (
                <TableComponents.Tr>
                  <TableComponents.Td id={`${partner.partner} partner`}>
                    {partner.partner}
                  </TableComponents.Td>
                  <TableComponents.Td id={`${partner.partner} received`}>
                    {checkValue(partner.valueReceived).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </TableComponents.Td>
                  <TableComponents.Td id={`${partner.partner} passedOn`}>
                    {checkValue(partner.valuePassedOn).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </TableComponents.Td>
                  <TableComponents.Td id={`${partner.partner} income`}>
                    {checkValue(partner.income).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </TableComponents.Td>
                </TableComponents.Tr>
              );
            })}
          </TableComponents.Tbody>
          <TableComponents.Tfooter>
            <TableComponents.Tr>
              <TableComponents.Td>Total</TableComponents.Td>
              <TableComponents.Td>
                {totalReceived.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </TableComponents.Td>
              <TableComponents.Td>
                {totalPassedOn.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </TableComponents.Td>
              <TableComponents.Td>
                {totalIncome.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </TableComponents.Td>
            </TableComponents.Tr>
          </TableComponents.Tfooter>
        </TableComponents.Table>
      </ContentCard>
    </Card>
  );
}

export default CardWithTable;
